/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Caption_Settings_TabInputs */



/**
* | output |
* | --- |
* | "Caption Settings" |
*
* @param {Live_Caption_Caption_Settings_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_caption_settings_tab = /** @type {((inputs?: Live_Caption_Caption_Settings_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Caption_Settings_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteleinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de legenda")
	return /** @type {LocalizedString} */ ("Caption Settings")
});